export default (path: string) => path.substring(path.lastIndexOf('/') + 1)
